import React from 'react';
import Logo from './Logo';

export default function Header({ title, showLogo = true }) {
  return (
    <div className="banner">
      {showLogo && (
        <div className="headerLogo">
          <Logo color="white" />
        </div>
      )}
      <h2>{title}</h2>
    </div>
  );
}